var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34339 10.2191L11.1766 2.30555C11.6314 1.89815 12.3686 1.89815 12.8234 2.30555L21.6566 10.2191C22.3902 10.8763 21.8706 12 20.8332 12H19V20C19 21.1046 18.1046 22 17 22H7C5.89543 22 5 21.1046 5 20V12H3.16678C2.12937 12 1.60983 10.8763 2.34339 10.2191ZM8.58283 15.2132L11.196 17.685C11.64 18.105 12.36 18.105 12.804 17.685L15.4172 15.2132C16.1943 14.4781 16.1943 13.2864 15.4172 12.5513C14.6401 11.8162 13.3801 11.8162 12.603 12.5513L12 13.1217L11.397 12.5513C10.6199 11.8162 9.35993 11.8162 8.58283 12.5513C7.80572 13.2864 7.80572 14.4781 8.58283 15.2132Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseHeart);
export default __webpack_public_path__ + "static/media/house-heart.601b5347d7ba3f0b81eaef7607b4e095.svg";
export { ForwardRef as ReactComponent };